































































































































































import { computed, defineComponent, reactive, ref, watch, getCurrentInstance } from '@vue/composition-api';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import _ from 'lodash';
import i18n, { i18n_t } from '@/locales/i18n';
import { countWorkDay } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import timezones from '@/renderer/scripts/utils/timezones';
import meetingHandler from '../meetingHandler';
dayjs.extend(utc);
dayjs.extend(timezone);
export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const userNickname = computed(() => store.getters.userBaseInfo.nickname);
    const exactTimeZone = ref('');
    const baseStartTime = ref(dayjs().add(1, 'hours').format());
    const formData = reactive({
      subject: '',
      type: 0,
      start_time: baseStartTime.value,
      end_time: dayjs().add(2, 'hours').format('YYYY-MM-DD HH:mm'),
      meeting_type: false,
      openPassword: false,
      password: '',
      recurring_type: 0,
      until_type: 0,
      until_date: dayjs().add(6, 'days').format('YYYY-MM-DD'),
      until_count: 7,
      enable_doc_upload_permission: true,
      // auto_record_type: true,
      timezone: 'China Standard Time',
    });
    const validator = reactive({
      subjectValidateTip: '',
      endTimeValidateTip: '',
      startTimeValidateTip: '',
      passwordValidateTip: '',
    });
    const scheduleDisabled = ref(false);
    const disableRepeatDate = reactive({
      before: dayjs(formData.start_time).subtract(0, 'day').format(),
      after: dayjs(formData.start_time).add(200, 'day').format(),
    });
    const disableStartDate = reactive({
      before: dayjs().subtract(0, 'day').format(),
    });
    const disableEndDate = reactive({
      before: dayjs(formData.start_time).subtract(0, 'day').format(),
      after: dayjs(formData.start_time).add(1, 'day').format(),
    });
    const { recurringOptions, methods: meetingMethods } = meetingHandler();
    const methods = {
      validateSubject(val: string) {
        if (val === '') {
          validator.subjectValidateTip = i18n_t('会议主题不能为空');
        } else {
          validator.subjectValidateTip = '';
        }
        methods.handleScheduleDisable();
      },
      validateStartTime(val: string) {
        const diffTime =
          exactTimeZone.value === ''
            ? dayjs(dayjs(val)).diff(dayjs())
            : dayjs(dayjs(val).format('YYYY-MM-DD HH:mm')).diff(
                dayjs().tz(exactTimeZone.value).format('YYYY-MM-DD HH:mm'),
              );
        if (diffTime <= 0) {
          validator.startTimeValidateTip = i18n_t('会议开始时间不能早于当前时间');
        } else if (dayjs(val).diff(dayjs(formData.end_time)) > 0) {
          validator.startTimeValidateTip = '';
          validator.endTimeValidateTip = '';
        } else {
          validator.startTimeValidateTip = '';
        }
        methods.handleScheduleDisable();
      },
      validateEndTime(val: string) {
        if (dayjs(val).diff(dayjs(formData.start_time)) <= 0) {
          validator.endTimeValidateTip = i18n_t('会议结束时间不能早于开始时间');
        } else {
          validator.endTimeValidateTip = '';
        }
        methods.handleScheduleDisable();
      },
      validatePassword(val: string) {
        if (!/^[0-9]*$/.test(val)) {
          validator.passwordValidateTip = i18n_t('密码仅可输入纯数字');
        } else if (val.length < 4) {
          validator.passwordValidateTip = i18n_t('密码需要至少4-6位数字');
        } else {
          validator.passwordValidateTip = '';
        }
        methods.handleScheduleDisable();
      },
      handleTimeZoneChange(val: any) {
        const timeZoneArea = (timezones.find(item => item.value === val.value) as any).utc[0];
        exactTimeZone.value = timeZoneArea;
        const aTime = dayjs(baseStartTime.value).subtract(0, 'day').format('YYYY-MM-DD');
        const bTime = dayjs(baseStartTime.value).tz(exactTimeZone.value).subtract(0, 'day').format('YYYY-MM-DD');
        const diffDay = dayjs(aTime).diff(dayjs(bTime), 'days');
        disableStartDate.before = dayjs().tz(exactTimeZone.value).subtract(diffDay, 'day').format();
        formData.start_time = dayjs(baseStartTime.value).tz(exactTimeZone.value).format('YYYY-MM-DD HH:mm');
      },
      handleRepeatmeetingCount() {
        switch (formData.recurring_type) {
          // 每天
          case 0:
            formData.until_count =
              dayjs(dayjs(formData.until_date).format('YYYY-MM-DD')).diff(
                dayjs(formData.start_time).format('YYYY-MM-DD'),
                'days',
              ) + 1;
            break;
          // 每个工作日
          case 1:
            formData.until_count = countWorkDay(dayjs(formData.start_time).format('YYYY-MM-DD'), formData.until_date);
            break;
          // 每周
          case 2:
            formData.until_count =
              Math.floor((dayjs(formData.until_date).diff(dayjs(formData.start_time), 'days') + 1) / 7) + 1;
            break;
          // 每两周
          case 3:
            formData.until_count =
              Math.floor((dayjs(formData.until_date).diff(dayjs(formData.start_time), 'days') + 1) / 14) + 1;
            break;
          // 每月
          case 4:
            formData.until_count =
              dayjs(dayjs(formData.until_date).add(1, 'days')).diff(dayjs(formData.start_time), 'months') + 1;
            break;
          default:
            break;
        }
      },
      handleScheduleDisable() {
        if (
          validator.subjectValidateTip === '' &&
          validator.startTimeValidateTip === '' &&
          validator.endTimeValidateTip === '' &&
          validator.passwordValidateTip === ''
        ) {
          scheduleDisabled.value = false;
        } else {
          scheduleDisabled.value = true;
        }
      },
      handleOpenPasswordChange(val: boolean) {
        if (!val) {
          validator.passwordValidateTip = '';
          methods.handleScheduleDisable();
        } else {
          formData.password = '';
          scheduleDisabled.value = true;
        }
      },
      handleUntilTypeChange(val: number) {
        if (val !== 1) {
          methods.handleRepeatmeetingCount();
        }
      },
      async submitScheduleMeeting() {
        const recurringRule = {
          recurring_type: formData.recurring_type,
          until_type: formData.until_type,
          until_date: (+dayjs(formData.until_date) / 1000).toString(),
          until_count: formData.until_count,
        };
        const opt = {
          meetingConfig: {
            subject: formData.subject,
            type: 0,
            start_time: (dayjs(formData.start_time).valueOf() / 1000).toString(),
            end_time: (dayjs(formData.end_time).valueOf() / 1000).toString(),
            meeting_type: formData.meeting_type ? 1 : 0,
            password: formData.password,
            recurring_rule: formData.meeting_type ? recurringRule : null,
            enable_doc_upload_permission: formData.enable_doc_upload_permission,
          },
          // auto_record_type: formData.auto_record_type ? 'cloud' : 'none',
        };

        const joinUrl = await meetingMethods.scheduleMeeting(opt);
        if (joinUrl) {
          innerShow.value = false;
          setTimeout(() => {
            dispatchRouter(joinUrl);
          }, 100);
        }
      },
    };
    const throttleValidateSubject = _.throttle(methods.validateSubject, 500);
    const throttleValidateEndTime = _.throttle(methods.validateEndTime, 500);
    const throttleValidateStartTime = _.throttle((val: string) => {
      methods.validateStartTime(val);
      baseStartTime.value = val;
    }, 500);
    watch(innerShow, val => {
      if (val) {
        formData.subject = i18n_t('{slot1}预定的会议', {
          slot1: userNickname.value,
        });
        formData.start_time = dayjs().add(1, 'hours').format('YYYY-MM-DD HH:mm');
        formData.end_time = dayjs().add(2, 'hours').format('YYYY-MM-DD HH:mm');
        formData.until_date = dayjs().add(6, 'days').format('YYYY-MM-DD');
        formData.meeting_type = false;
        formData.openPassword = false;
        formData.password = '';
        formData.recurring_type = 0;
        formData.until_type = 0;
        formData.timezone = 'China Standard Time';
        formData.enable_doc_upload_permission = true;
        validator.startTimeValidateTip = '';
        validator.endTimeValidateTip = '';
        validator.passwordValidateTip = '';
        validator.subjectValidateTip = '';
        methods.handleRepeatmeetingCount();
      }
    });
    watch(
      () => formData.start_time,
      val => {
        if (val) {
          formData.until_date = dayjs(val).add(6, 'days').format('YYYY-MM-DD');
          formData.end_time = dayjs(val).add(1, 'hours').format('YYYY-MM-DD HH:mm');
          disableRepeatDate.before = dayjs(val).subtract(0, 'day').format();
          disableRepeatDate.after = dayjs(val).add(200, 'day').format();
          disableEndDate.before = dayjs(val).subtract(0, 'day').format();
          disableEndDate.after = dayjs(val).add(1, 'day').format();
          methods.handleRepeatmeetingCount();
        }
      },
    );
    return {
      dayjs,
      validator,
      innerShow,
      formData,
      recurringOptions,
      disableRepeatDate,
      disableStartDate,
      disableEndDate,
      scheduleDisabled,
      throttleValidateSubject,
      throttleValidateEndTime,
      throttleValidateStartTime,
      timezones,
      ...methods,
      ...meetingMethods,
    };
  },
});
